import React, { useContext } from 'react';
import styled from 'styled-components';
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';

import { SubHeading } from '../../components/ui/SubHeading';
import { UserContext } from '../../contexts/UserContext';

const BarcodeSettings = () => {
  const { Site, handleSiteChange } = useContext(UserContext);
  const {
    siteType,
    custom1,
    custom1Enabled,
    custom2,
    custom2Enabled,
    custom3,
    custom3Enabled,
    autoBarcode,
    barcodeEnabled,
    barcodePrefix,
    barcodeSuffix,
    printedBarcode,
  } = Site;

  return (
    <div className='setting'>
      <div className='barcode-settings'>
        <SubHeading> <ViewColumnIcon style={Iconstyles}/> Barcode Settings</SubHeading>
        <FormControl>
          <InputLabel id='printedBarcode'>Printed Barcode</InputLabel>
          <Select
            name='printedBarcode'
            value={printedBarcode}
            onChange={handleSiteChange}
            label='Printed Barcode'
            labelId='printedBarcode'
            disabled={!barcodeEnabled}
          >
            <MenuItem value='externalID'>{`${
              siteType === 0 || siteType === 5 ? 'Student' : 'Staff'
            } ID`}</MenuItem>
            {siteType === 0 || siteType === 5 ? (
              <MenuItem value='curriculum'>Curriculum</MenuItem>
            ):(<></>)}
            {custom1Enabled && <MenuItem value='custom1'>{custom1}</MenuItem>}
            {custom2Enabled && <MenuItem value='custom2'>{custom2}</MenuItem>}
            {custom3Enabled && <MenuItem value='custom3'>{custom3}</MenuItem>}
          </Select>
        </FormControl>

        <TextField
          name='barcodePrefix'
          value={barcodePrefix}
          onChange={handleSiteChange}
          label='Barcode Prefix'
          disabled={!autoBarcode || !barcodeEnabled}
        />
        <TextField
          name='barcodeSuffix'
          value={barcodeSuffix}
          onChange={handleSiteChange}
          label='Barcode Suffix'
          disabled={!autoBarcode || !barcodeEnabled}
        />
        <Checkboxes>
          <FormControlLabel
            control={
              <Checkbox
                name='autoBarcode'
                onChange={handleSiteChange}
                checked={autoBarcode}
                disabled={!barcodeEnabled}
              />
            }
            label='Generate Barcode'
          />
          <FormControlLabel
            control={
              <Checkbox
                name='barcodeEnabled'
                onChange={handleSiteChange}
                checked={barcodeEnabled}
              />
            }
            label='Enable Barcode'
          />
        </Checkboxes>
      </div>
    </div>
  );
};

 const Iconstyles ={
   fontSize:'17px'
  }

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.1rem;
`;

export default BarcodeSettings;
